import React, { useEffect, useState } from 'react';
import { bool, string, func, shape, oneOf, oneOfType, arrayOf, instanceOf } from 'prop-types';
import { genericStorage } from '@ajaibid/utils';

import { CoachMark as BaseCoachMark } from './react-coach-mark';
import Marker from './Marker';
import Content from './Content';
import './style.css';

const Coachmark = (props) => {
  const { cacheKey, list, show } = props;

  // The cacheValue is a binary string, where 1 represents that the step has been completed
  // and vice versa.
  const completedSteps = [...(genericStorage.get(cacheKey) || '0'.repeat(list.length))].map(Number);
  const prevStep = completedSteps.indexOf(0);

  const [step, setStep] = useState(prevStep);

  const nextStep = () => {
    // If the step is marked as clear, update the binary string in cacheValue
    completedSteps[step] = 1;
    genericStorage.set(cacheKey, completedSteps.join(''));
    setStep(step + 1);
  };

  useEffect(() => {
    // Every step update, perform the following checks
    if (completedSteps[step] === 1) {
      // If current step is already completed, skip this step
      setStep(step + 1);
    }
    if (list[step]?.prerequisite !== undefined && !list[step]?.prerequisite) {
      // If current step has not met prerequisite yet, skip this step
      setStep(step + 1);
    }
    // Otherwise, continue as normal
  }, [step, completedSteps, list]);

  const normalizedList = list.map((o, i) => ({
    activate: step === i,
    component: (
      <>
        <Marker position={o.position} />
        <Content
          title={o.title}
          description={o.description}
          actionText={o.actionText}
          onClick={nextStep}
        />
      </>
    ),
    reference: o.reference,
    tooltip: { position: o.position },
  }));

  if (!show) return null;

  return <BaseCoachMark {...normalizedList[step]} />;
};

Coachmark.propTypes = {
  cacheKey: string,
  list: arrayOf(
    shape({
      title: string,
      description: string,
      actionText: string,
      reference: oneOfType([func, shape({ current: instanceOf(Element) })]),
      prerequisite: bool,
      position: oneOf([
        'top',
        'top-left',
        'top-right',
        'bottom',
        'bottom-left',
        'bottom-right',
        'left',
        'right',
      ]),
    })
  ),
  show: bool,
};

Coachmark.defaultProps = {
  cacheKey: '',
  list: [],
  show: true,
};

export default Coachmark;
